import { render } from "./CarouselElement.vue?vue&type=template&id=571b1f20&scoped=true"
import script from "./CarouselElement.vue?vue&type=script&lang=js"
export * from "./CarouselElement.vue?vue&type=script&lang=js"

import "./CarouselElement.vue?vue&type=style&index=0&id=571b1f20&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571b1f20"]])

export default __exports__